export default function getBaseDomain() {
  const gOrigin = window.location.origin;
  const gHost = new URL(gOrigin).hostname;

  const splitedDomain = gHost.split('.');
  const domain = `${splitedDomain.at(-2)}.${splitedDomain.at(-1)}`;

  //   const domain = `${gHost.split('.').at(-2)}.${gHost.split('.').at(-1)}`;
  return domain;
}
